import { useQuery } from '@tanstack/react-query';

import { COUNTER_KEYS } from '@/constants/queryKeys';
import { countersService } from '@/services/counters';
import { errorUtils } from '@/services/errors';
import { useStaffSession } from '@/hooks/auth';

const useCounters = () => {
  const { data: session } = useStaffSession();

  return useQuery({
    queryKey: COUNTER_KEYS.root,
    queryFn: async () => errorUtils.unwrap(await countersService.readCounters()),
    enabled: session?.stage === 'ready',
    refetchOnReconnect: true,
  });
};

export {
  useCounters,
};
